import * as api from './api';
import Selectors from './selectors';
import { COLORS, DEFAULT_RADIUS } from './constants';

export const REQUEST_ACTIVE_GEOFENCES = 'REQUEST_ACTIVE_GEOFENCES';
export const REQUEST_ACTIVE_GEOFENCES_ERROR = 'REQUEST_ACTIVE_GEOFENCES_ERROR';
export const SET_ACTIVE_GEOFENCES = 'SET_ACTIVE_GEOFENCES';
export const ADD_GEOFENCES = 'ADD_GEOFENCES';
export const REPLACE_GEOFENCE = 'REPLACE_GEOFENCE';

export const ADD_NEW_GEOFENCE = 'ADD_NEW_GEOFENCE';
export const EDIT_NEW_GEOFENCE = 'EDIT_NEW_GEOFENCE';
export const SAVE_NEW_GEOFENCE = 'SAVE_NEW_GEOFENCE';
export const SAVE_NEW_GEOFENCE_SUCCESS = 'SAVE_NEW_GEOFENCE_SUCCESS';
export const SAVE_NEW_GEOFENCE_ERROR = 'SAVE_NEW_GEOFENCE_ERROR';

export const UPDATE_GEOFENCE = 'UPDATE_GEOFENCE';
export const UPDATE_GEOFENCE_SUCCESS = 'UPDATE_GEOFENCE_SUCCESS';
export const UPDATE_GEOFENCE_ERROR = 'UPDATE_GEOFENCE_ERROR';

export const REMOVE_GEOFENCE = 'REMOVE_GEOFENCE';
export const REMOVE_GEOFENCE_SUCCESS = 'REMOVE_GEOFENCE_SUCCESS';
export const REMOVE_GEOFENCE_ERROR = 'REMOVE_GEOFENCE_ERROR';

export const SET_GEOFENCE_VISIBLE = 'SET_GEOFENCE_VISIBLE';
export const SET_ALL_GEOFENCES_VISIBLE = 'SET_ALL_GEOFENCES_VISIBLE';
export const SET_GEOFENCE_AS_IMPORTED = 'SET_GEOFENCE_AS_IMPORTED';

export const START_EDITING_GEOFENCE = 'START_EDITING_GEOFENCE';
export const STOP_EDITING_GEOFENCE = 'STOP_EDITING_GEOFENCE';

export const EDIT_GEOFENCE_VALIDITY = 'EDIT_GEOFENCE_VALIDITY';
export const EDIT_GEOFENCE_COORDINATES = 'EDIT_GEOFENCE_COORDINATES';
export const EDIT_GEOFENCE_TYPE = 'EDIT_GEOFENCE_TYPE';
export const EDIT_GEOFENCE_GEOJSON_PROPERTIES = 'EDIT_GEOFENCE_GEOJSON_PROPERTIES';

const action = (type, payload) => ({
    type,
    payload
});

function visible(geofence) {
    geofence.visible = true;
    return geofence;
}

function wrap(geofence) {
    if (!geofence || typeof geofence !== 'object') return geofence;

    const result = {
        geofenceId: geofence.geofenceId
    };
    for (let key in geofence) {
        if(key !== 'geofenceId') {
            result[key] = { value: geofence[key] };
        }
    }
    return result;
}

const setActiveGeofences = (geofences) => {
    const lookup = {};
    const activeGeofenceIds = [];
    if (geofences && geofences.length) {
        geofences.forEach(it => {
            lookup[it.geofenceId] = visible(wrap(it));
            activeGeofenceIds.push(it.geofenceId);
        });
    }
    return {
        type: SET_ACTIVE_GEOFENCES,
        payload: {
            lookup,
            activeGeofenceIds
        }
    };
};

export const addGeofences = (geofences) => action(ADD_GEOFENCES, geofences.map(it => visible(wrap(it))));

export const setAllGeofencesVisible = (visible) => ({
    type: SET_ALL_GEOFENCES_VISIBLE,
    payload: { visible }
});

export const setGeofenceVisible = (geofenceId, visible) => ({
    type: SET_GEOFENCE_VISIBLE,
    payload: { geofenceId, visible }
});

export const loadActiveGeofences = stage => (dispatch, getState) => {
    if (Selectors.loading(getState())) {
        return Promise.resolve();
    }
    dispatch(action(REQUEST_ACTIVE_GEOFENCES));
    return api.fetchActiveGeofences(stage)
        .then(geofences => dispatch(setActiveGeofences(geofences)))
        .catch(err => dispatch(action(REQUEST_ACTIVE_GEOFENCES_ERROR, err)));
};

const nextDefaultColor = (state) => {
    const colorCounts = Selectors.activeGeofenceIds(state).reduce((acc, id) => {
        const color = Selectors.geofenceColor(state, id);
        if (acc[color]) {
            acc[color] += 1;
        } else {
            acc[color] = 1;
        }
        return acc;
    }, {});
    // either the first unused, or the least used
    return COLORS.find(it => !colorCounts[it])
        || COLORS.sort((a, b) => colorCounts[a] - colorCounts[b])[0];
}

export const addNewGeofence = () => (dispatch, getState) => {
    const newGeofence = {
        style: {
            'fill-color': nextDefaultColor(getState())
        },
        geojson: {
            geometry: {
                type: 'Point',            
            },
            properties: {
                radius: DEFAULT_RADIUS,
                area: 0
            }
        },
        notification: {
            enter: true,
            exit: true
        },
        isValid: true,
        error: null,
        imported: false
    };
    dispatch(action(ADD_NEW_GEOFENCE, { new: wrap(newGeofence), editingGeometry:newGeofence.geojson }));
    return Promise.resolve();
};

export const startGeometryEdit = (geofenceId) => (dispatch, getState) => {
    if (!geofenceId) {
        dispatch(action(START_EDITING_GEOFENCE, {}));
        return Promise.resolve();
    }
    const geometry = Selectors.geofenceGeojson(getState(), geofenceId);
    if(!geometry) {
        console.error('existing geofence has no geometry');
        dispatch(action(START_EDITING_GEOFENCE, {}));
        return Promise.resolve();
    }
    dispatch(action(START_EDITING_GEOFENCE, geometry));
    return Promise.resolve();
}

export const saveGeometryEdit = (stage, geofenceId) => (dispatch, getState) => {
    const state = getState();
    const geojson = Selectors.editingGeometry(state);
    if (!geofenceId) {
        const newGeofence = {
            name: Selectors.geofenceName(state),
            description: Selectors.geofenceAddress(state),
            style: Selectors.geofenceStyle(state),
            end: Selectors.geofenceExpiryDate(state),
            notification: Selectors.geofenceNotification(state),
            geojson
        };
        dispatch(action(SAVE_NEW_GEOFENCE));
        return api.addGeofence(stage, newGeofence)
            .then(response => {
                dispatch(action(SAVE_NEW_GEOFENCE_SUCCESS, visible(wrap(response))));
                return response.geofenceId;
            }).catch(error => dispatch(action(SAVE_NEW_GEOFENCE_ERROR, { error, newGeofence })));
    }
    const geofence = {
        geofenceId,
        description: Selectors.geofenceAddress(state),
        geojson
    };
    dispatch(action(UPDATE_GEOFENCE, { geofenceId, geojson: { value: geojson, pending: true } }));
    dispatch(action(STOP_EDITING_GEOFENCE));
    return api.updateGeofence(stage, geofence)
        .then(response => {
            if (geofenceId !== response.geofenceId) {
                dispatch(action(REPLACE_GEOFENCE, { oldId: geofenceId, newGeofence: visible(wrap(response)) }));
            } else {
                dispatch(action(UPDATE_GEOFENCE_SUCCESS, wrap(response)));
            }
            return response.geofenceId;
        }).catch(error => dispatch(action(UPDATE_GEOFENCE_ERROR, { error, geofence })));
}

export const cancelGeometryEdit = () => action(STOP_EDITING_GEOFENCE);

export const editGeofenceAddress = (address) => {
    return action(EDIT_GEOFENCE_GEOJSON_PROPERTIES, { address });
}

export const editGeofenceRadiusInKm = (radiusInKm) => {
    return action(EDIT_GEOFENCE_GEOJSON_PROPERTIES, { radius: radiusInKm * 1000 });
}

export const editGeofenceArea = (area) => {
    return action(EDIT_GEOFENCE_GEOJSON_PROPERTIES, { area: area });
}

export const editGeofenceCoordinates = (coordinates, center) => (dispatch) => {
    dispatch(action(EDIT_GEOFENCE_COORDINATES, { coordinates }));
    
    if(coordinates){
        const addressCoordinates = center || coordinates;
    
        return api.lookupAddress(addressCoordinates[0], addressCoordinates[1])
        .then(address => dispatch(editGeofenceAddress(address)))
        .catch(error => console.warn(error));
    }else{
        dispatch(editGeofenceAddress(undefined))
    }
}

export const importGeofence = (coordinates, center) => (dispatch) => {
    dispatch(editGeofenceCoordinates(coordinates, center));
    dispatch(action(SET_GEOFENCE_AS_IMPORTED));
}

export const setGeofenceNotification = (stage, geofenceId, notification) => (dispatch, getState) => {
    if (!geofenceId) {
        dispatch(action(EDIT_NEW_GEOFENCE, { notification: { value: notification } }));
        return Promise.resolve();
    }
    const geofence = {
        geofenceId,
        notification
    };
    dispatch(action(UPDATE_GEOFENCE, { geofenceId, notification: { value: notification, pending: true } }));
    return api.updateGeofence(stage, geofence)
        .then(response => {
            dispatch(action(UPDATE_GEOFENCE_SUCCESS, wrap(response)));
        }).catch(error => dispatch(action(UPDATE_GEOFENCE_ERROR, { error, geofence })));
}

export const setGeofenceStyle = (stage, geofenceId, style) => (dispatch, getState) => {
    if (!geofenceId) {
        dispatch(action(EDIT_NEW_GEOFENCE, { style: { value: style } }));
        return Promise.resolve();
    }
    const geofence = {
        geofenceId,
        style
    };
    dispatch(action(UPDATE_GEOFENCE, { geofenceId, style: { value: style, pending: true } }));
    return api.updateGeofence(stage, geofence)
        .then(response => {
            dispatch(action(UPDATE_GEOFENCE_SUCCESS, wrap(response)));
        }).catch(error => dispatch(action(UPDATE_GEOFENCE_ERROR, { error, geofence })));
}

export const setGeofenceName = (stage, geofenceId, name) => (dispatch, getState) => {
    if (!geofenceId) {
        dispatch(action(EDIT_NEW_GEOFENCE, { name: { value: name } }));
        return Promise.resolve();
    }
    const geofence = {
        geofenceId,
        name
    };
    dispatch(action(UPDATE_GEOFENCE, { geofenceId, name: { value: name, pending: true } }));
    return api.updateGeofence(stage, geofence)
        .then(response => {
            dispatch(action(UPDATE_GEOFENCE_SUCCESS, wrap(response)));
        }).catch(error => dispatch(action(UPDATE_GEOFENCE_ERROR, { error, geofence })));
}

export const setGeofenceType = (stage, geofenceId, geofenceType) => (dispatch, getState) => {
        dispatch(action(EDIT_GEOFENCE_TYPE, { type: geofenceType, coordinates: null }));
        dispatch(action(EDIT_GEOFENCE_GEOJSON_PROPERTIES, { area: 0, radius:  DEFAULT_RADIUS}));
        if(geofenceType === "Polygon"){
            dispatch(action(EDIT_GEOFENCE_VALIDITY, { isValid: false, error: null}));
        }

        return Promise.resolve();
}

export const convertGeofence = (stage, geofenceId, newGeojson) => (dispatch, getState) => {
    dispatch(action(EDIT_GEOFENCE_COORDINATES, { coordinates: newGeojson.geometry.coordinates, type: newGeojson.geometry.type }));
    dispatch(action(EDIT_GEOFENCE_GEOJSON_PROPERTIES, { area: newGeojson.properties.area, radius: newGeojson.properties.radius }));
    return Promise.resolve();
}

export const setGeofenceValidity = (isValid, error) => (dispatch, getState) => {
    dispatch(action(EDIT_GEOFENCE_VALIDITY, { isValid, error }));
    return Promise.resolve();
}

export const setGeofenceExpiryDate = (stage, geofenceId, expiryDate) => (dispatch, getState) => {
    if (!geofenceId) {
        dispatch(action(EDIT_NEW_GEOFENCE, { end: { value: expiryDate } }));
        return Promise.resolve();
    }
    const geofence = {
        geofenceId,
        end: expiryDate
    };
    dispatch(action(UPDATE_GEOFENCE, { geofenceId, end: { value: expiryDate, pending: true } }));
    return api.updateGeofence(stage, geofence)
        .then(response => {
            dispatch(action(UPDATE_GEOFENCE_SUCCESS, wrap(response)));
        }).catch(error => dispatch(action(UPDATE_GEOFENCE_ERROR, { error, geofence })));
}

export const removeGeofence = (stage, geofenceId) => (dispatch, getState) => {
    dispatch(action(REMOVE_GEOFENCE, geofenceId));
    return api.removeGeofence(stage, geofenceId)
        .then(response => {
            dispatch(action(REMOVE_GEOFENCE_SUCCESS, geofenceId))
        }).catch(error => dispatch(action(REMOVE_GEOFENCE_ERROR, { error, geofenceId })));
}
